import styled from 'styled-components';

const Main = styled.div`
  margin: 0 auto;
`;

export default Main;
